import * as React from 'react';

import {GoogleOAuthProvider, GoogleLogin} from '@react-oauth/google';
import type {CredentialResponse} from '@react-oauth/google';

import {Card} from 'shells/card/card';
import {colors} from 'shells/colors/colors';
// @ts-expect-error - imported from .js/.jsx file
import {LoadingIcon} from 'shells/icon/svg/loading-icon';
import {useResizeObserver} from 'shells/utils/hooks/use-resize-observer';

import {getGoogleAppClientId} from '../utils';

import styles from './google-oauth-button.module.css';

export const GOOGLE_OAUTH_BUTTON_ID = 'google-oauth-button';

type Props = {
    variant: 'login' | 'signup';
    onGoogleOAuthSuccess: (token: string) => void;
    onGoogleOAuthFailure: () => void;
    showLoadingSpinner: boolean;
};

function LoginButtonComponent(props: Props) {
    const [buttonWidth, setButtonWidth] = React.useState<string>('400px');

    const buttonRef = React.useRef(undefined);

    const [width] = useResizeObserver(
        buttonRef && buttonRef.current ? buttonRef.current : undefined
    );

    React.useEffect(() => {
        if (width) {
            setButtonWidth(`${Math.round(width)}px`);
        }
    }, [width]);

    const copy = props.variant === 'login' ? 'signin_with' : 'continue_with';
    const loadingCopy = `${props.variant === 'login' ? 'Logging in' : 'Signing up'} with Google…`;

    return (
        // @ts-expect-error
        <div ref={buttonRef} className={styles['google-oauth-button-container']}>
            {props.showLoadingSpinner ? (
                <Card hasBorder={true}>
                    <div className={styles['loading-placeholder']}>
                        <div>{loadingCopy}</div>
                        <LoadingIcon size={29} fill={colors.offWhiteDk} />
                    </div>
                </Card>
            ) : (
                <GoogleLogin
                    // @ts-expect-error
                    id={GOOGLE_OAUTH_BUTTON_ID}
                    onSuccess={(response: CredentialResponse) => {
                        // @ts-expect-error
                        props.onGoogleOAuthSuccess(response.credential);
                    }}
                    onError={props.onGoogleOAuthFailure}
                    width={buttonWidth}
                    text={copy}
                    use_fedcm_for_prompt={true}
                    use_fedcm_for_button={true}
                />
            )}
        </div>
    );
}

export function GoogleOAuthButton(props: Props) {
    return (
        <GoogleOAuthProvider clientId={getGoogleAppClientId()}>
            <LoginButtonComponent {...props} />
        </GoogleOAuthProvider>
    );
}
